import { createFileRoute } from "@tanstack/react-router";

import { AboutPage } from "../about";

export const Route = createFileRoute("/en/about")({
	headers: () => ({
		"Cache-Control":
			"public, max-age=0, s-maxage=86400, stale-while-revalidate=604800",
	}),
	head: () => ({
		meta: [
			{ title: "About Us | Makedonijaturist AD" },
			{
				name: "description",
				content:
					"Learn more about Makedonijaturist AD, our history, mission, and values. Leading hotel group in Macedonia since 1963.",
			},
		],
		links: [
			{
				rel: "canonical",
				href: "https://makedonijaturist.com.mk/en/about",
			},
		],
	}),
	component: AboutPage,
});
